import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionSummary, AccordionDetails, useTheme } from "@mui/material";
import { ReactNode, useContext, useEffect, useState } from "react";
import { BNButton, BNInlineSvgIcon, BNStack, resolveUrl, UmbracoLink, getRouteAction } from "@bn-monorepo/js-packages";
import { SettingsContext } from "../../../settingsContext";

interface Props {
  link: UmbracoLink;
  iconInlineSvg?: string;
  children: ReactNode;
}

export const BNHeaderMegaMenuExpandable: React.FC<Props> = ({ link, iconInlineSvg, children }) => {
  const { env } = useContext(SettingsContext);
  const theme = useTheme();
  const id = link.name;
  const [isJs, setIsJs] = useState(false);
  useEffect(() => setIsJs(true), []);
  return (
    <Accordion
      //Must be div when isJs since else Enter doesn't work
      component={isJs ? "div" : "details"}
      slotProps={{ heading: { component: "summary" } }}
      sx={{
        "&::before": {
          height: 0,
        },
        "&[open]": {
          ".MuiCollapse-root": {
            height: "auto",
            visibility: "visible",
          },
          ".MuiAccordionSummary-expandIconWrapper": {
            transform: "rotate(180deg)",
          },
        },
        "&.Mui-expanded": {
          my: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore sx={{ color: "tertiary.main" }} />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
        slotProps={{ root: { component: "div" } }}
        sx={{
          backgroundColor: theme.vars.palette.secondary.lighter,
          py: 0,
          ["&.Mui-focusVisible"]: {
            outline: "none",
            [".MuiAccordionSummary-expandIconWrapper"]: {
              outline: "auto",
            },
          },
        }}
      >
        <BNButton
          component={"a"}
          href={resolveUrl(link.url)}
          data-uit={getRouteAction(link.url)}
          variant="text"
          textDecoration={false}
          sx={{ px: 0, fontSize: "1.3rem" }}
          startIcon={
            iconInlineSvg ? (
              <BNInlineSvgIcon
                svgString={iconInlineSvg}
                sx={{
                  color: theme.vars.palette.tertiary.dark,
                  width: "2.4rem",
                  height: "2.4rem",
                  ml: 0.5,
                  mr: 1,
                }}
              />
            ) : undefined
          }
          data-cms-target-key={env !== "prod" ? link.udi : undefined}
        >
          {link.name}
        </BNButton>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          backgroundColor: theme.vars.palette.secondary.lighter,
        }}
      >
        <BNStack
          sx={{
            gap: "0.2rem",
            borderRadius: 2,

            "& > :first-of-type": {
              borderTopLeftRadius: theme.shape.borderRadius * 2,
              borderTopRightRadius: theme.shape.borderRadius * 2,
            },

            "& > :last-of-type": {
              borderBottomLeftRadius: theme.shape.borderRadius * 2,
              borderBottomRightRadius: theme.shape.borderRadius * 2,
            },
          }}
        >
          {children}
        </BNStack>
      </AccordionDetails>
    </Accordion>
  );
};
